
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 0C3.12666 0 0 3.12666 0 7C0 10.8733 3.12666 14 7 14C10.8733 14 14 10.8733 14 7C14 3.12666 10.8733 0 7 0ZM7.66619 5.77512V10.8182H6.31454V5.77512H7.66619ZM6.23531 4.47008C6.23531 4.26811 6.30211 4.10187 6.43572 3.97137C6.57244 3.84086 6.75732 3.77561 6.99037 3.77561C7.2203 3.77561 7.40363 3.84086 7.54035 3.97137C7.67707 4.10187 7.74543 4.26811 7.74543 4.47008C7.74543 4.67516 7.67551 4.84295 7.53569 4.97345C7.39897 5.10396 7.2172 5.16921 6.99037 5.16921C6.76354 5.16921 6.58021 5.10396 6.44039 4.97345C6.30367 4.84295 6.23531 4.67516 6.23531 4.47008Z","fill":"#EB5757"}})])
          )
        }
      }
    